"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactOtpInput = _interopRequireDefault(require("react-otp-input"));
var _styles = require("./styles");
var _excluded = ["colorType", "isError", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var CodeValidation = function CodeValidation(_ref) {
  var colorType = _ref.colorType,
    isError = _ref.isError,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styles.Wrapper, {
    colorType: colorType,
    isError: isError,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_reactOtpInput["default"], _extends({
    numInputs: 4
  }, rest, {
    containerStyle: "container",
    inputStyle: "input",
    errorStyle: "error"
  })));
};
CodeValidation.propTypes = {
  colorType: _propTypes["default"].string,
  className: _propTypes["default"].string,
  isError: _propTypes["default"].bool
};
var _default = exports["default"] = CodeValidation;